import { doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import {
  parseGroupTimelineColorsDoc,
  seedGroupTimelineColorEntries,
  type GroupTimelineColorEntry,
  type GroupTimelineColorsDoc,
} from './groupTimelineCanonicalColors';

export const GROUP_TIMELINE_COLORS_DOC_ID = 'group_timeline_colors';

function docRef() {
  return doc(db, 'settings', GROUP_TIMELINE_COLORS_DOC_ID);
}

export function subscribeGroupTimelineColors(
  onData: (doc: GroupTimelineColorsDoc) => void,
  onError?: (err: Error) => void,
): () => void {
  return onSnapshot(
    docRef(),
    snap => {
      const parsed = parseGroupTimelineColorsDoc(snap.data() as Record<string, unknown> | undefined);
      onData(parsed);
    },
    err => {
      console.warn('[groupTimelineColorsSettings] subscribe', err);
      onError?.(err);
      onData(parseGroupTimelineColorsDoc(null));
    },
  );
}

export async function saveGroupTimelineColors(
  entries: GroupTimelineColorEntry[],
  actor: { uid: string; name: string },
): Promise<void> {
  await setDoc(
    docRef(),
    {
      entries: entries.map(e => ({
        id: e.id,
        kind: e.kind,
        matchKey: e.matchKey,
        label: e.label,
        color: e.color,
      })),
      updatedAt: serverTimestamp(),
      updatedByUid: actor.uid,
      updatedByName: actor.name,
    },
    { merge: true },
  );
}

export async function resetGroupTimelineColorsToSeed(actor: { uid: string; name: string }): Promise<void> {
  await saveGroupTimelineColors(seedGroupTimelineColorEntries(), actor);
}
